import React from "react";
import HoverTooltip from "Components/Common/components/HoverTooltip";

type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';

type OverlayIconProps = {
  message?: string | React.ReactNode;
  placement?: TooltipPosition;
  useFixed?: boolean;
};

const OverlayIcon = ({ message = "", placement = "top", useFixed = true }: OverlayIconProps) => {
  return (
    <HoverTooltip text={message} position={placement} useFixed={useFixed}>
      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3977_3515)">
          <path d="M15.0001 8.02469C14.4601 18.9898 -1.53567 17.381 0.120159 6.53298C2.01518 -2.39761 14.8687 -1.00639 15.0001 8.02469ZM6.74964 7.80922C6.5741 9.5568 4.78379 13.5647 8.11906 12.7329C9.24622 12.5102 9.78208 10.0499 8.56562 11.9435C6.37598 12.909 9.58088 7.00328 7.75258 6.19942C7.11612 5.62759 5.59374 6.63761 5.71796 7.2664C6.07109 7.7191 6.93647 6.46772 6.74964 7.80922ZM7.38097 5.23291C8.53277 5.322 8.89309 3.39417 7.68586 3.18077C6.38111 2.88346 6.029 5.18837 7.38097 5.23291Z" fill="#A7A9AF" />
        </g>
        <defs>
          <clipPath id="clip0_3977_3515">
            <rect width="15" height="15" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </HoverTooltip>
  );
};

export default OverlayIcon;
